





































































import DictMixin from '@/mixins/dict-mixin';
import { mixins } from 'vue-class-component';
import moment from 'moment';
import { Component, Prop, PropSync } from 'vue-property-decorator';
@Component
export default class JobDetail extends mixins(DictMixin) {
  @PropSync('detail') syncDetail!: any;
  @Prop() name!: any;
  handleTimeStr = '';
  triggerTimeStr = '';
  
  created() {
    this.handleTimeStr = this.syncDetail.handleTime && moment(this.syncDetail.handleTime).format('YYYY-MM-DD HH:mm:ss');
    this.triggerTimeStr = this.syncDetail.triggerTime && moment(this.syncDetail.triggerTime).format('YYYY-MM-DD HH:mm:ss');
  }
}
